export default "__VITE_ASSET__Ca9zOnym__"